module.exports = __webpack_public_path__ + "static/img/03.5b85f0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cats/03.jpg
// module id = 611
// module chunks = 4